export type DashboardKey = 'site' | 'vendas' | 'financeiro'

export interface DashboardDef {
  key: DashboardKey
  label: string
  path: string
  resource: string
}

export const DASHBOARDS: DashboardDef[] = [
  { key: 'site', label: 'Site', path: '/dashboard/site', resource: 'settings' },
  { key: 'vendas', label: 'Vendas', path: '/dashboard/vendas', resource: 'crm' },
  { key: 'financeiro', label: 'Financeiro', path: '/dashboard/financeiro', resource: 'rentals' }
]

export const LANDING_ORDER: DashboardKey[] = ['vendas', 'site', 'financeiro']

export const DASHBOARD_ROOT = '/dashboard'

export function allowedDashboards(canRead: (resource: string) => boolean): DashboardDef[] {
  return DASHBOARDS.filter(dashboard => canRead(dashboard.resource))
}

export function landingDashboard(allowed: DashboardDef[], last?: string | null): DashboardDef | null {
  const remembered = allowed.find(dashboard => dashboard.key === last)
  if (remembered) return remembered
  for (const key of LANDING_ORDER) {
    const dashboard = allowed.find(item => item.key === key)
    if (dashboard) return dashboard
  }
  return null
}

const lastDashboardKey = (companyId: string) => `@Habitar:dashboard:last:${companyId}`

export function readLastDashboard(companyId?: string | null): string | null {
  if (!companyId) return null
  try {
    return localStorage.getItem(lastDashboardKey(companyId))
  } catch {
    return null
  }
}

export function rememberDashboard(companyId: string | null | undefined, key: DashboardKey): void {
  if (!companyId) return
  try {
    localStorage.setItem(lastDashboardKey(companyId), key)
  } catch {
    return
  }
}
